(function () {
  var GIFT_PROPERTY = '_free_gift';
  var CORE_PROPERTY = '_core_subscription';

  function initWidget(widget) {
    if (widget.dataset.etPlansReady) return;
    widget.dataset.etPlansReady = 'true';

    var idInput = widget.querySelector('[data-et-id-input]');
    var planInput = widget.querySelector('[data-et-selling-plan-input]');
    var qtyInput = widget.querySelector('[data-et-qty-input]');
    var options = widget.querySelectorAll('[data-et-plan-option]');
    var radios = widget.querySelectorAll('[data-et-plan-radio]');
    var form = widget.querySelector('form');
    var atc = widget.querySelector('[data-et-atc]');
    var errorWrap = widget.querySelector('.product-form__error-message-wrapper');
    var errorMsg = widget.querySelector('.product-form__error-message');

    function select(radio) {
      options.forEach(function (opt) {
        opt.classList.toggle('is-selected', opt.contains(radio));
      });
      if (idInput) idInput.value = radio.getAttribute('data-et-variant-id') || '';
      if (planInput) planInput.value = radio.getAttribute('data-et-selling-plan') || '';
      if (qtyInput) qtyInput.value = '1';

      /* Tell the gallery to swap its main (featured) image. */
      var featured = radio.getAttribute('data-et-featured');
      if (featured) {
        document.dispatchEvent(
          new CustomEvent('et:subs:plan-change', { detail: { featured: featured } })
        );
      }
    }

    function selectedRadio() {
      return widget.querySelector('[data-et-plan-radio]:checked') || radios[0];
    }

    function buildItems(radio) {
      var items = [];
      var variantId = radio.getAttribute('data-et-variant-id');
      if (!variantId) return items;

      var main = { id: Number(variantId), quantity: 1 };
      var sellingPlan = radio.getAttribute('data-et-selling-plan');
      if (sellingPlan) main.selling_plan = Number(sellingPlan);
      var mainProps = {};
      mainProps[CORE_PROPERTY] = 'true';
      main.properties = mainProps;
      items.push(main);

      var giftIds = (radio.getAttribute('data-et-gift-ids') || '')
        .split(',')
        .map(function (s) { return s.trim(); })
        .filter(Boolean);

      giftIds.forEach(function (gid) {
        var props = {};
        props[GIFT_PROPERTY] = 'true';
        items.push({ id: Number(gid), quantity: 1, properties: props });
      });

      return items;
    }

    function showError(message) {
      if (errorMsg) errorMsg.textContent = message;
      if (errorWrap) errorWrap.hidden = false;
    }

    function clearError() {
      if (errorWrap) errorWrap.hidden = true;
      if (errorMsg) errorMsg.textContent = '';
    }

    function setLoading(state, el) {
      var target = el || atc;
      if (!target) return;
      target.classList.toggle('is-loading', state);
      if ('disabled' in target) target.disabled = state;
    }

    function addToCart(items, trigger) {
      if (!items.length) {
        showError('Selecteer een optie.');
        return;
      }
      clearError();
      setLoading(true, trigger);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) {
              throw new Error(data.description || data.message || 'Add to cart failed');
            }
            return data;
          });
        })
        .then(function () {
          /* Straight to checkout — the button stays in loading state until navigation. */
          window.location.href = '/checkout';
        })
        .catch(function (err) {
          setLoading(false, trigger);
          showError(err.message || 'Er ging iets mis. Probeer het opnieuw.');
        });
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) select(radio);
      });
    });

    var checked = selectedRadio();
    if (checked) {
      checked.checked = true;
      select(checked);
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var radio = selectedRadio();
        if (!radio) return;
        addToCart(buildItems(radio), atc);
      });
    }

    /* One-time purchase adds the first product (no subscription) directly on click. */
    var oneTime = widget.querySelector('[data-et-onetime]');
    if (oneTime) {
      oneTime.addEventListener('click', function () {
        var vid = oneTime.getAttribute('data-et-variant-id');
        if (!vid) return;
        addToCart([{ id: Number(vid), quantity: 1 }], oneTime);
      });
    }

    initGiftPopup(widget);
  }

  var CLOSING = 'et-subs-plans__modal--closing';

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function openModal(modal) {
    modal.classList.remove(CLOSING);
    if (modal.open) return;
    if (typeof modal.showModal === 'function') {
      modal.showModal();
    } else {
      modal.setAttribute('open', '');
    }
  }

  function hardClose(modal) {
    modal.classList.remove(CLOSING);
    if (typeof modal.close === 'function' && modal.open) {
      modal.close();
    } else {
      modal.removeAttribute('open');
    }
  }

  function closeModal(modal) {
    if (!modal.open) return;
    if (reducedMotion()) {
      hardClose(modal);
      return;
    }
    if (modal.classList.contains(CLOSING)) return;
    modal.classList.add(CLOSING);

    var settled = false;
    var finish = function () {
      if (settled) return;
      if (!modal.classList.contains(CLOSING)) {
        settled = true;
        modal.removeEventListener('animationend', onEnd);
        return;
      }
      settled = true;
      modal.removeEventListener('animationend', onEnd);
      hardClose(modal);
    };
    var onEnd = function (event) {
      if (event && event.target !== modal) return;
      finish();
    };
    modal.addEventListener('animationend', onEnd);
    setTimeout(finish, 320);
  }

  function initGiftPopup(widget) {
    var modal = widget.querySelector('[data-et-gift-modal]');
    if (!modal) return;

    var titleEl = modal.querySelector('.et-subs-plans__modal-title');
    var bodyEl = modal.querySelector('.et-subs-plans__modal-body');

    widget.querySelectorAll('[data-et-gift-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        /* Don't let the click toggle the plan radio (the trigger sits inside the label). */
        event.preventDefault();
        event.stopPropagation();

        var tpl = trigger.closest('.et-subs-plans__gift').querySelector('.et-subs-plans__gift-data');
        if (!tpl) return;

        if (titleEl) titleEl.textContent = tpl.getAttribute('data-title') || '';
        if (bodyEl) {
          bodyEl.innerHTML = '';
          bodyEl.appendChild(tpl.content.cloneNode(true));
        }
        openModal(modal);
      });
    });

    modal.querySelectorAll('[data-et-modal-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeModal(modal);
      });
    });

    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal(modal);
    });

    modal.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeModal(modal);
    });
  }

  /* Coming back from checkout restores the page from the back/forward cache
     with the ATC / one-time button still disabled in its loading state. */
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-et-atc], [data-et-onetime]').forEach(function (btn) {
      btn.classList.remove('is-loading');
      btn.disabled = false;
    });
  });

  function init(root) {
    (root || document).querySelectorAll('[data-et-subs-plans]').forEach(initWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
